import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-policy-at-root',
  templateUrl: './no-policy-at-root.component.html',
  styleUrls: ['./no-policy-at-root.component.scss']
})
export class NoPolicyAtRootComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
